import { Button } from 'bench-internal-theme';
import React from 'react';
import { withApollo } from '@apollo/client/react/hoc';

import { GET_BALANCES_DATA } from './queries';
import { ApolloClient } from '@apollo/client';
import { DateRange } from './types';

type RefreshGLBalanceButtonContainerProps = {
  client?: ApolloClient<any>;
  dateRange: DateRange;
  clientId: string;
};

const RefreshGLBalanceButtonContainer = ({
  client: apolloClient,
  dateRange,
  clientId,
}: RefreshGLBalanceButtonContainerProps) => (
  <Button
    icon="refresh"
    onClick={() => {
      if (!dateRange || !dateRange.startDate || !dateRange.endDate) {
        return;
      }
      const query = GET_BALANCES_DATA;
      const variables = {
        clientId,
        fromDate: dateRange.startDate,
        toDate: dateRange.endDate,
        filterZeroEntryLedgers: true,
      };
      apolloClient?.query({ fetchPolicy: 'network-only', query, variables });
    }}
    size="xsmall"
    styleType="total-ghost"
    title="Recalculate Balance"
  />
);

export default withApollo<RefreshGLBalanceButtonContainerProps>(RefreshGLBalanceButtonContainer);
